import TableViewToggles, { TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../configuration/setup/store';

export type ViewState = {
    tableViewType: TableViewTogglesViewType;
    isFetchingTriggeredByUser: boolean;
};

export const initialViewState = {
    tableViewType: TableViewToggles.VIEW_TYPE_TABLE,
    isFetchingTriggeredByUser: false,
};

export const viewSlice = createSlice({
    name: 'view',
    initialState: initialViewState,
    reducers: {
        setTableViewType: (state: ViewState, action: PayloadAction<TableViewTogglesViewType>) => {
            state.tableViewType = action.payload;
        },
        setIsFetchingTriggeredByUser: (state: ViewState, action: PayloadAction<boolean>) => {
            state.isFetchingTriggeredByUser = action.payload;
        },
    },
});

export const getTableViewType = (state: RootState) => state.portal.view.tableViewType;
export const getIsFetchingTriggeredByUser = (state: RootState) => state.portal.view.isFetchingTriggeredByUser;
